// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './util/request'
// import axios from 'axios'
import Vant from 'vant'
import 'vant/lib/index.css'

import { Tree } from 'element-ui'

// 增加全局遮罩层
import loadingIndex from '@/component/loading/loadingIndex'

Vue.use(Vant)
Vue.use(loadingIndex)
Vue.use(Tree)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let prevUrl = window.location.protocol + '//' + window.location.host + '/#' + from.fullPath
  let url = window.location.protocol + '//' + window.location.host + '/#' + to.fullPath
  let title = document.title
  sendData(prevUrl, url, title)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

function sendData (prevUrl, url, title) {
  if (!window.location.href.includes('127.0.0.1') && !window.location.href.includes('localhost') && !window.location.href.includes('172.')) {
    let query = {
      terminal: '1',
      // eslint-disable-next-line no-undef
      IP: returnCitySN.cip,
      prevUrl: prevUrl,
      url: url,
      title: title
    }
    let formData = new FormData()
    formData.append('terminal', query.terminal)
    formData.append('IP', query.IP)
    formData.append('prevUrl', query.prevUrl)
    formData.append('url', query.url)
    formData.append('title', query.title)
    axios.post('https://m.easthome.com/mindex/dataSend', formData).then(res => {})
  }
}



// WEBPACK FOOTER //
// ./src/main.js